import React from 'react';
import classNames from "classnames";
import styles from "../styles/carousel.module.scss"

import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export class CarouselSlotProps extends BaseProps {
  order: Number;
}

export const CarouselSlot = (props: CarouselSlotProps) => {
  const containerProps = {
    style: {
      order: props.order,
    },
    className: classNames(styles.item_container),
  };


  return (
    <div {...containerProps}>
      {props.children}
    </div>
  )
};
